import { render } from "./signin.vue?vue&type=template&id=70e5cb5b"
import script from "./signin.vue?vue&type=script&lang=js"
export * from "./signin.vue?vue&type=script&lang=js"
script.render = render

export default script